// Palet en bedragweergave van de publieke herbestelpagina.
//
// Stonden tot de eenscherm-ronde (15-09) als losse constanten in
// `HerbestelPagina.tsx`. Nu de pagina uit meerdere blokbestanden bestaat
// is één bron nodig: twee bestanden met elk hun eigen "#ef7f01" lopen
// vroeg of laat uit elkaar. Zelfde waarden als voorheen, uit het palet
// van de andere publieke shop-pagina's (retour, tevredenheid).

import { formatEuro } from "@/lib/utils";

/** brand-orange-600 — knoppen en accenten. */
export const ORANJE = "#ef7f01";
/** brand-orange-700 — hover van de oranje knop. */
export const ORANJE_DONKER = "#d77200";
/** De combideal-kaart. */
export const BLAUW = "#4fc1e9";
/** Bevestiging: gratis verzending, op voorraad, een gelukte code. */
export const GROEN = "#2E9E5B";
/** Spaarpunten. */
export const PUNTEN_KLEUR = "#8a5a1a";
/** Uitgeschakelde knop. */
export const GRIJS = "#98a4ad";
/** Vlak-tint van het publieke palet: de adresregel draagt hem, zodat
 *  die regel opvalt tussen de witte kaarten zonder een kaart te worden. */
export const TINT = "#f7f9fb";
/** De rand van de adresregel op die tint. */
export const TINT_RAND = "#e3e9ef";

/** Een bedrag in centen als "€ 13,35"; `null` wordt "€ —". */
export function euro(cents: number | null | undefined): string {
  return cents == null ? "€ —" : formatEuro(cents / 100);
}
